module.exports = __webpack_public_path__ + "static/media/referal.c097c1c3.svg";